import { render, staticRenderFns } from "./EditField.vue?vue&type=template&id=67bc42cc&scoped=true&"
import script from "./EditField.vue?vue&type=script&lang=js&"
export * from "./EditField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bc42cc",
  null
  
)

export default component.exports